'use client';

import { SpeedInsights } from '@vercel/speed-insights/next';
import { Analytics } from '@vercel/analytics/react';
import { sanitizeAnalyticsUrl } from '../utils/analyticsUrl';

// Vercel Web Analytics and Speed Insights record the page URL too. Some URLs
// carry an email or a one-time token (/auth-confirm/<email>/<id>,
// /magic?token=…, /mcp/upload#<token>), so both get the same sanitiser as GA4.
// `beforeSend` is a function, which a server component (app/layout.js) cannot
// pass down — hence this small client wrapper.
const cleanEvent = (event) => (event && event.url
  ? { ...event, url: sanitizeAnalyticsUrl(event.url) }
  : event);

export default function VercelTelemetry() {
  return (
    <>
      <SpeedInsights beforeSend={cleanEvent} />
      <Analytics beforeSend={cleanEvent} />
    </>
  );
}
